export default function state() {
    return {
        erklaerungsText: undefined,
        arzneimittelvorschlaege: undefined
    }
}